import React from "react";
import get from "lodash/get";
import Helmet from "react-helmet";
import Hero from "../components/hero";
import Aside from "../components/aside";
import Slides from "../components/slidesContainer";
import Skills from "../components/skillsContainer";
import Education from "../components/educationContainer";
import Portfolio from "../components/portfolioContainer";
import Experience from "../components/experienceContainer";
import TextContent from "../components/textContent";
import ArticlePreview from "../components/article-preview";
import ContactForm from "../components/contactForm";
import Banner from "../components/banner";

const typeMatrix = {
  ContentfulSlidesContainer: Slides,
  ContentfulTextContent: TextContent,
  ContentfulSkillsContainer: Skills,
  ContentfulEducationContainer: Education,
  ContentfulExperienceContainer: Experience,
  ContentfulPortfolioContainer: Portfolio,
  ContentfulContactForm: ContactForm,
  ContentfulBanner: Banner
};

class RootIndex extends React.Component {
  componentDidMount() {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "js/jquery.min.js";
    document.head.appendChild(s);

    const awaitJQuery = () => {
      setTimeout(() => {
        if (window.jQuery) {
          const scripts = [
            "js/jquery.easing.1.3.js",
            "js/bootstrap.min.js",
            "js/jquery.waypoints.min.js",
            "js/jquery.flexslider-min.js",
            "js/owl.carousel.min.js",
            "js/jquery.countTo.js",
            "js/main.js"
          ];

          scripts.forEach(script => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = script;
            document.head.appendChild(s);
          });
        } else {
          awaitJQuery();
        }
      }, 100);
    };

    awaitJQuery();
  }

  render() {
    const siteTitle = get(this, "props.data.site.siteMetadata.title");
    const profile = get(this, "props.data.allContentfulProfile.edges")[0].node;
    const home = get(this, "props.data.allContentfulPageContainer.edges")[0]
      .node;
    return (
      <div style={{ background: "#fff" }}>
        <Helmet title={siteTitle} />
        <div id="colorlib-page">
          <div className="container-wrap">
            <a
              aria-controls="navbar"
              aria-expanded="false"
              className="js-colorlib-nav-toggle colorlib-nav-toggle"
              data-target="#navbar"
              data-toggle="collapse"
              href="#"
            >
              <i />
            </a>
            <Aside
              {...profile}
              sections={home.sections.map(section => section.sectionName)}
            />
            <div id="colorlib-main">
              {(home.sections &&
                home.sections.length &&
                home.sections.map(section => {
                  const Component = typeMatrix[section.internal.type];
                  return <Component {...section} key={section.internal.type} />;
                })) ||
                "Hello world"}
              <div className="footer-disclaimer">
                &copy; Copyright Andrew Oakes 2019{" "}
                <p>
                  This template is made with{" "}
                  <i aria-hidden="true" className="icon-heart" /> by{" "}
                  <a href="https://colorlib.com" target="_blank">
                    Colorlib
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RootIndex;

export const pageQuery = graphql`
  query HomeQuery {
    allContentfulProfile(
      filter: { contentful_id: { eq: "2DssWN68FYb13TYqEs5liP" } }
    ) {
      edges {
        node {
          name
          job
          location
          profileImage {
            file {
              url
            }
          }
          socialMedia {
            type
            fullUrl
            customHtml {
              customHtml
            }
          }
        }
      }
    }

    allContentfulPageContainer(
      filter: { contentful_id: { eq: "5dvmsKLUzrqQDTbWN1RhM1" } }
    ) {
      edges {
        node {
          name
          sections {
            ... on ContentfulSlidesContainer {
              internal {
                type
              }
              sectionName
              slides {
                buttonLink
                externalLink
                heading
                textContent {
                  textContent
                }
                includeButton
                buttonText
                buttonImage
                convertToBlackWhite
                backgroundImage {
                  file {
                    url
                  }
                }
              }
            }
            ... on ContentfulTextContent {
              internal {
                type
              }
              sectionName
              textContent {
                textContent
              }
            }
            ... on ContentfulSkillsContainer {
              internal {
                type
              }
              sectionName
              heading
              skills {
                heading
                icon
                colour
                textContent {
                  textContent
                }
              }
            }
            ... on ContentfulEducationContainer {
              internal {
                type
              }
              sectionName
              heading
              skills {
                location
                educationName
                mainSubjects
                dates
              }
            }
            ... on ContentfulExperienceContainer {
              internal {
                type
              }
              sectionName
              heading
              experience {
                link
                character
                play
                description {
                  description
                }
                dates
              }
            }
            ... on ContentfulPortfolioContainer {
              internal {
                type
              }
              sectionName
              heading
              portfolioItems {
                name
                type
                portfolioItem {
                  file {
                    url
                  }
                }
                coverImage {
                  file {
                    url
                  }
                }
              }
            }
            ... on ContentfulContactForm {
              internal {
                type
              }
              sectionName
              heading
              email
              address
              emailContactMethods {
                email
                title
              }
            }
          }
        }
      }
    }
  }
`;

/*


*/



// WEBPACK FOOTER //
// ./src/pages/index.js